import { currencyKey } from "./constants";

export const numToCurrency = (num, addSpace = false) => {
  const currency = localStorage.getItem(currencyKey) || "";

  const space = addSpace ? " " : "";

  return currency + space + num?.toLocaleString();
};
